"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.3,2.3V1.1h.39A1.19,1.19,0,0,0,7.52,0H6.58A1.19,1.19,0,0,0,5.41,1.1h.46V2.3H5.39V4.76H8.71V2.3Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.2,2.3V1.1h.39A1.19,1.19,0,0,0,17.42,0h-.93a1.19,1.19,0,0,0-1.18,1.1h.46V2.3h-.48V4.76h3.32V2.3Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.77,21.7v1.2h-.39A1.19,1.19,0,0,0,16.55,24h.93a1.19,1.19,0,0,0,1.18-1.1H18.2V21.7h.48V19.24H15.35V21.7Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.87,21.7v1.2H5.47A1.19,1.19,0,0,0,6.65,24h.93a1.19,1.19,0,0,0,1.18-1.1H8.3V21.7h.48V19.24H5.46V21.7Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "3.83",
    y: "5.27",
    width: "16.34",
    height: "13.46",
    rx: "1.05",
    ry: "1.05",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "10.53",
    r: "0.48",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "12",
    y1: "11.01",
    x2: "12",
    y2: "13.89",
    fill: "#004864"
  }));
};

exports["default"] = _default;